<template>
    <div class="scale-component d-flex">
        <div
            v-for="option in this.options"
            :key="option.id"
            class="scale-item"
            :class="{
                active: isSelected(option.id),
                'not-selected': !isSelected(option.id),
            }"
            @click="updateInputValue(option.id)"
        >
            <div class="btn-scale">
                <i v-if="isSelected(option.id)" class="icon-cr icon-ok" />
            </div>
            <span class="scale-label text-uppercase">{{ option.sub_text }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ScaleChoiceComponent',
        props: {
            options: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                selectedChoice: null,
            };
        },
        methods: {
            updateInputValue(value) {
                this.selectedChoice = value;
                this.$emit('update-selection', this.selectedChoice);
            },
            isSelected(id) {
                return this.selectedChoice === id;
            },
        },
    };
</script>
